import React from 'react';
import { Box, Typography } from '@mui/material';

// Small key: old -> new table, reused for both node data-field changes
// (type/label/promptType/matchMode) and edge field changes.
export default function MetaChangesTable({ changes }) {
  if (!changes?.length) return null;
  return (
    <Box sx={{ mb: 1.5 }}>
      {changes.map(({ field, oldValue, newValue }) => (
        <Box
          key={field}
          sx={{ display: 'flex', gap: 1.5, py: 0.5, borderBottom: '1px solid', borderColor: 'divider' }}
        >
          <Typography sx={{ fontWeight: 600, width: 110, flexShrink: 0, fontSize: 12, color: 'text.secondary' }}>
            {field}
          </Typography>
          <Typography sx={{ fontSize: 12 }}>
            <Box component="span" sx={{ color: 'error.main', textDecoration: 'line-through' }}>
              {String(oldValue)}
            </Box>
            {' → '}
            <Box component="span" sx={{ color: 'success.main' }}>{String(newValue)}</Box>
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
